import * as React from 'react';
import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import userStyles from '../../app/user-management/UserStyle';
import { HeadCell, Order } from '../../types/table';

const StyledTableCell = withStyles(() =>
    createStyles({
    })
)(TableCell);

const StyledTableRow = withStyles(() =>
    createStyles({
    })
)(TableRow);

type EnhancedTableProps = {
    onRequestSort: (event: React.MouseEvent<unknown>, property: any) => void;
    order: Order;
    orderBy: string | number | symbol;
    headCells: HeadCell[];
};
export const EnhancedTableHead = (props: EnhancedTableProps): JSX.Element => {
    const { order, orderBy, onRequestSort } = props;
    const classes = userStyles();

    const createSortHandler = (headcell: HeadCell) => (event: React.MouseEvent<unknown>): void => {
        if (!headcell.hideSorting)
            onRequestSort(event, headcell.id);
    };
    return (
        <TableHead>
            <StyledTableRow style={{ width: '100%' }}>
                <StyledTableCell style={{ backgroundColor: '#ffffff' }} padding="default">&nbsp;</StyledTableCell>
                {props.headCells.map((headCell) => (
                    <StyledTableCell style={{ backgroundColor: '#ffffff' }}
                        key={headCell.id}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                    <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell)}
                            hideSortIcon ={ headCell.hideSorting}
                        >
                            {headCell.label}
                            {(orderBy === headCell.id ) ?(
                                <span className={classes.visuallyHiddenArrow}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null }
                        </TableSortLabel>
                    </StyledTableCell>
                ))}
                <StyledTableCell style={{ backgroundColor: '#ffffff' }} padding="checkbox"></StyledTableCell>
                <StyledTableCell style={{ backgroundColor: '#ffffff' }} padding="checkbox"></StyledTableCell>
            </StyledTableRow>
        </TableHead>
    );
};
